<ng-container *ngIf="innerHtmlContent">
    <div [innerHTML]="safeHtmlContent"></div>
</ng-container>

